import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FileAttachmentsState } from '../reducers/fileattachments.reducer';

export const fileattachmentsState: any = createFeatureSelector<FileAttachmentsState>('fileAttachments');

export const fileAttachmentsDataOrder = createSelector(fileattachmentsState, (state: any) => {
  return state.fileAttachmentsDataOrder;
});
